import { PIPELINE_MAP } from 'model/deals.model';
import { FilterState } from './DealsFilters.types';


export const calculateActiveFilterCount = (filterState: FilterState): number => {
  let count = 0;
  if (filterState.dealHealth !== null) count++;
  if (filterState.owner !== null) count++;
  if (filterState.client !== null) count++;
  if (filterState.startDate !== null || filterState.closeDate !== null) count++;
  return count;
};


export const hasActiveFilters = (filterState: FilterState): boolean => {
  return calculateActiveFilterCount(filterState) > 0;
};


export const createInitialFilterState = (): FilterState => ({
  dealHealth: null,
  owner: null,
  client: null,
  startDate: null,
  closeDate: null,
});


export const filtersToQueryParams = (
  filterState: FilterState,
  selectedPipelines: string[],
  tabValue: number,
  searchTerm?: string,
  needsAttention?: boolean,
): Record<string, any> => {
  const params: Record<string, any> = {};

  params.mine = tabValue === 0;

  if (needsAttention) {
    params.needAttention = true;
  }

  if (filterState.dealHealth?.Id) {
    params.dealHealth = filterState.dealHealth.Id;
  }

  if (filterState.owner?.Name) {
    params.ownerName = filterState.owner.Name;
  }

  if (filterState.client?.Name) {
    params.clientName = filterState.client.Name;
  }

  if (filterState.startDate) {
    params.closeDateFrom = filterState.startDate.format('YYYY-MM-DD');
  }
  if (filterState.closeDate) {
    params.closeDateTo = filterState.closeDate.format('YYYY-MM-DD');
  }

  if (selectedPipelines.length > 0) {
    const apiValues = selectedPipelines
      .map((displayName) => {
        if (displayName.includes('/')) {
          return displayName.replace('/', '_');
        }
        return PIPELINE_MAP[displayName] || displayName;
      })
      .join(',');
    params.pipelineType = apiValues;
  }

  // Search term
  if (searchTerm && searchTerm.trim()) {
    params.search = searchTerm.trim();
  }

  return params;
};
